import { useHttpClient } from '@/common/api/httpClient';
import type { ShapeResponse } from './models/shapeResponse';
import { processShape } from '../domain/processShape';
import type { ShapeRequest } from './models/shapeRequest';
import { useLanguageStore } from 'shared/translations/stores/languageStore';
import { storeToRefs } from 'pinia';
import { useShapeStore } from 'shared/shapes/stores/shapeStore';

export interface UpdateShapeRequest {
  shapeId: string;
  shape: ShapeRequest;
}

export interface UpdateShapeResponse {
  ok: true;
  shape: ShapeResponse;
}

export function useUpdateShape() {
  const httpClient = useHttpClient();
  const languageStore = useLanguageStore();
  const { translations } = storeToRefs(languageStore);
  const store = useShapeStore();

  return {
    execute,
  };

  async function execute(action: UpdateShapeRequest) {
    const shapeId = action.shapeId;

    const headers = httpClient.defaultHeaders();
    const request = new Request(httpClient.siteUrl(`shape/${shapeId}`), {
      headers,
      method: 'PUT',
      body: JSON.stringify(action.shape),
    });

    const text = translations.value.shapes.actions.update;

    const response = await httpClient.action<UpdateShapeResponse>(request, {
      title: text.title,
      errorTitle: text.error,
      async processOk(response) {
        const shape = await response.json() as ShapeResponse;
        processShape(shape);
        store.add(shape);
        return {
          ok: true,
          shape: shape,
        };
      },
    });

    return response;
  }
}
